import { get, update } from 'idb-keyval';
import { reportStorageError, STORAGE_KEYS } from './browserStorage';

/** Context for AI: recent searches persist in IndexedDB (idb-keyval), not localStorage; separate keys for NLS vs keyword, capped at 5 and case-insensitively de-duped. */
const MAX_RECENT_SEARCHES = 5;

const getStorageKey = (isNLS: boolean) =>
	(isNLS ? STORAGE_KEYS.recentSearchesNLS : STORAGE_KEYS.recentSearches).key;

const isStringArray = (value: unknown): value is string[] =>
	Array.isArray(value) && value.every((item) => typeof item === 'string');

const parseRecentSearches = (storedValue: string): string[] => {
	const parsed: unknown = JSON.parse(storedValue);

	return isStringArray(parsed) ? parsed : [];
};

export const getRecentSearches = async (isNLS: boolean): Promise<string[]> => {
	const key = getStorageKey(isNLS);

	try {
		const data = await get(key);

		return data ? parseRecentSearches(data) : [];
	} catch (error) {
		reportStorageError(error, key);

		return [];
	}
};

export const addRecentSearch = async (isNLS: boolean, newSearch: string): Promise<string[]> => {
	const key = getStorageKey(isNLS);
	let updatedList: string[] = [];

	try {
		await update(key, (oldValue) => {
			const newSearchTrimmed = newSearch.trim();

			if (!newSearchTrimmed) {
				return oldValue || JSON.stringify([]);
			}

			let allSearches: string[] = [];

			try {
				allSearches = oldValue ? parseRecentSearches(oldValue) : [];
			} catch (error) {
				reportStorageError(error, key);
			}

			const filtered = allSearches.filter(
				(s) => s.trim().toLowerCase() !== newSearchTrimmed.toLowerCase(),
			);

			updatedList = [newSearchTrimmed, ...filtered].slice(0, MAX_RECENT_SEARCHES);

			return JSON.stringify(updatedList);
		});
	} catch (error) {
		reportStorageError(error, key);
	}

	return updatedList;
};
